module.exports = __webpack_public_path__ + "media/images/smart_phone/item/kuchi_btn-0861c318e0ea6f6a80c6b43d7f3f0eac.gif";